<template>
	<div :class="'panel digit_steps theme-image'" style="background-image: url('/frontimg/bg_landing_top.jpg')">
		<div class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12">
						<h2>Ключевые направления деятельности</h2>
					</div>
				</div>
			</div>

			<div class="step-grid">
				<div class="step">
					<div class="digit">1</div>
					<div class="title">Прикладные и академические исследования</div>
					<div class="preview">
						<div class="description">
							<!-- <p>Исследования центра</p> -->
						</div>
						<a href="/centres/finance/sfice-research-reports/" class="btn btn-secondary">Подробнее</a>
					</div>
				</div>
				<div class="step">
					<div class="digit">2</div>
					<div class="title">Образование</div>
					<div class="preview">
						<div class="description">
							<p>Degree Programs (MBA/EMBA), открытые программы</p>
						</div>
						<a href="/centres/finance/sfice-programs/" class="btn btn-secondary">Подробнее</a>
					</div>
				</div>
				<div class="step">
					<div class="digit">3</div>
					<div class="title">Индустриальный диалог</div>
					<div class="preview">
						<div class="description">
							<p>Конференции, круглые столы, СМИ</p>
						</div>
						<a href="/centres/finance/financeevents/" class="btn btn-secondary">Подробнее</a>
					</div>
				</div>
				<div class="step">
					<div class="digit">4</div>
					<div class="title">Международное сотрудничество</div>
					<div class="preview">
						<div class="description">
							<p>Mastercard, HKUST, International alliance of International Financial Centres</p>
						</div>
						<!-- <a href="#" class="btn btn-secondary">Подробнее</a> -->
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: "themes-cards",
		props: ["block", "fetchedData"]
	};
</script>

<style lang="scss" scoped>
	@import "~/assets/styles/components/home/panel-digit-steps";
</style>